import { AddClientRequestBody, AddUserRequestBody, ClientUploadCSVRequestBody, EditClientRequestBody, EditUserRequestBody } from "../../common/model/suite/requestBody";
import { DeleteClientRequestParameter, DeleteUserRequestParameter, GetAllClientsRequestParameter, GetAllLocationsRequestParameter, GetAllUsersRequestParameter, LocationByIdRequestParameter } from "../../common/model/suite/requestParameter";
import { GetAllClientsResponseBody, GetAllLocationResponseBody, GetAllUserGroupsResponseBody, GetAllUsersResponseBody } from "../../common/model/suite/responseBody";
import { addClientParameter, addUserParameter, clientUploadCSVParameter, deleteClientRequestParameters, deleteUserParameter, editClientParameter, editUserParameter, getAllClientsParameter, getAllClientsResponseParameter, getAllLocationsParameter, getAllUserGroupsParameter, getAllUsersParameter, locationByIdParameter } from "../apiParameters";
import { baseResponseBody } from "../objectTypeConstants";

/* CLIENT MANAGEMENT */
export const addClientRequestBody: AddClientRequestBody = {
    clientId: addClientParameter.clientId,
    ero: addClientParameter.ero,
    mfj: addClientParameter.mfj,
    defaultSignFirst: addClientParameter.defaultSignFirst,
    locationId: addClientParameter.locationId,
    clientName: addClientParameter.clientName,
    clientEmailAddress: addClientParameter.clientEmailAddress,
    clientMobileNumber: addClientParameter.clientMobileNumber,
    clientCountryCode: addClientParameter.clientCountryCode,
    clientDOB: addClientParameter.clientDOB,
    clientSsnOrEin: addClientParameter.clientSsnOrEin,
    spouseName: addClientParameter.spouseName,
    spouseEmailAddress: addClientParameter.spouseEmailAddress,
    spouseMobileNumber: addClientParameter.spouseMobileNumber,
    spouseCountryCode: addClientParameter.spouseCountryCode,
    spouseDOB: addClientParameter.spouseDOB,
    spouseSsnOrEin: addClientParameter.spouseSsnOrEin,
    type: addClientParameter.type,
}

export const getAllClientsRequestParameter: GetAllClientsRequestParameter = {
    filterTextQuery: getAllClientsParameter.filterTextQuery,
    pageSizeQuery: getAllClientsParameter.pagesizeQuery,
    pageNumberQuery: getAllClientsParameter.pageNumberQuery,
    sortByQuery: getAllClientsParameter.sortByQuery,
    sortOrderQuery: getAllClientsParameter.sortOrderQuery
}

export const getAllClientsResponseBody: GetAllClientsResponseBody = {
    ...baseResponseBody,
    data: {
        uniqueId: getAllClientsResponseParameter.uniqueId,
        clientId: getAllClientsResponseParameter.clientId,
        clientName: getAllClientsResponseParameter.clientName,
        clientEmailAddress: getAllClientsResponseParameter.clientEmailAddress,
        clientMobileNumber: getAllClientsResponseParameter.clientMobileNumber,
        clientCountryCode: getAllClientsResponseParameter.clientCountryCode,
        clientDOB: getAllClientsResponseParameter.clientDOB,
        clientSsnOrEin: getAllClientsResponseParameter.clientSsnOrEin,
        spouseName: getAllClientsResponseParameter.spouseName,
        spouseEmailAddress: getAllClientsResponseParameter.spouseEmailAddress,
        spouseMobileNumber: getAllClientsResponseParameter.spouseMobileNumber,
        spouseCountryCode: getAllClientsResponseParameter.spouseCountryCode,
        spouseDOB: getAllClientsResponseParameter.spouseDOB,
        spouseSsnOrEin: getAllClientsResponseParameter.spouseSsnOrEin,
        type: getAllClientsResponseParameter.type,
        ero: getAllClientsResponseParameter.ero,
        mfj: getAllClientsResponseParameter.mfj,
        locationId: getAllClientsResponseParameter.locationId,
    }
}

export const deleteClientRequestParameter: DeleteClientRequestParameter = {
    uniqueIdQuery: deleteClientRequestParameters.uniqueIdQuery
}

export const editClientRequestBody: EditClientRequestBody = {
    uniqueId: editClientParameter.uniqueId,
    clientId: editClientParameter.clientId,
    type: editClientParameter.type,
    ero: editClientParameter.ero,
    mfj: editClientParameter.mfj,
    defaultSignFirst: editClientParameter.defaultSignFirst,
    locationId: editClientParameter.locationId,
    clientName: getAllClientsResponseParameter.clientName,
    clientEmailAddress: getAllClientsResponseParameter.clientEmailAddress,
    clientMobileNumber: getAllClientsResponseParameter.clientMobileNumber,
    clientCountryCode: getAllClientsResponseParameter.clientCountryCode,
    clientDOB: getAllClientsResponseParameter.clientDOB,
    clientSsnOrEin: getAllClientsResponseParameter.clientSsnOrEin,
    spouseName: getAllClientsResponseParameter.spouseName,
    spouseEmailAddress: getAllClientsResponseParameter.spouseEmailAddress,
    spouseMobileNumber: getAllClientsResponseParameter.spouseMobileNumber,
    spouseCountryCode: getAllClientsResponseParameter.spouseCountryCode,
    spouseDOB: getAllClientsResponseParameter.spouseDOB,
    spouseSsnOrEin: getAllClientsResponseParameter.spouseSsnOrEin,
}

export const clientUploadCSVRequestBody: ClientUploadCSVRequestBody = {
    document: clientUploadCSVParameter.document,
    fileName: clientUploadCSVParameter.fileName,
    callbackUri: clientUploadCSVParameter.callbackUri,
    correlationId: clientUploadCSVParameter.correlationId
}

/* OFFICE LOCATION */
export const getAllLocationsRequestParameter: GetAllLocationsRequestParameter = {
    filterTextQuery: getAllLocationsParameter.filterTextQuery,
    pageNumberQuery: getAllLocationsParameter.pageNumberQuery
}

export const getAllLocationResponseBody: GetAllLocationResponseBody = {
    ...baseResponseBody,
    data: {
        locationId: getAllLocationsParameter.locationId,
        isPrimary: getAllLocationsParameter.isPrimary,
        name: getAllLocationsParameter.name,
        countryCode: getAllLocationsParameter.countryCode,
        phone: getAllLocationsParameter.phone,
        address1: getAllLocationsParameter.address1,
        address2: getAllLocationsParameter.address2,
        city: getAllLocationsParameter.city,
        zip: getAllLocationsParameter.zip,
        fax: getAllLocationsParameter.fax,
        website: getAllLocationsParameter.website,
        state: getAllLocationsParameter.state
    }
}

export const locationByIdRequestParameter: LocationByIdRequestParameter = {
    locationIdQuery: locationByIdParameter.locationIdQuery
}

export const locationByIdResponseBody: GetAllLocationResponseBody = {
    ...baseResponseBody,
    data: {
        locationId: locationByIdParameter.locationId,
        isPrimary: locationByIdParameter.isPrimary,
        name: locationByIdParameter.name,
        countryCode: locationByIdParameter.countryCode,
        phone: locationByIdParameter.phone,
        address1: locationByIdParameter.address1,
        address2: locationByIdParameter.address2,
        city: locationByIdParameter.city,
        zip: locationByIdParameter.zip,
        fax: locationByIdParameter.fax,
        website: locationByIdParameter.website,
        state: locationByIdParameter.state
    }
}

/* USER MANAGEMENT */
export const addUserRequestBody: AddUserRequestBody = {
    firstName: addUserParameter.firstName,
    lastName: addUserParameter.lastName,
    emailAddress: addUserParameter.emailAddress,
    phone: addUserParameter.phone,
    extension: addUserParameter.extension,
    fax: addUserParameter.fax,
    mobileNumber: addUserParameter.mobileNumber,
    countryCode: addUserParameter.countryCode,
    ptin: addUserParameter.ptin,
    userGroups: addUserParameter.userGroups,
    officeLocations: addUserParameter.officeLocations,
    isMFAEnabled: addUserParameter.isMFAEnabled,
}

export const getAllUsersRequestParameter: GetAllUsersRequestParameter = {
    nameQuery: getAllUsersParameter.nameQuery,
    emailQuery: getAllUsersParameter.emailQuery,
    pageSizeQuery: getAllUsersParameter.pageSizeQuery,
    pageNumberQuery: getAllUsersParameter.pageNumberQuery,
    sortByQuery: getAllUsersParameter.sortByQuery,
    sortOrderQuery: getAllUsersParameter.sortOrderQuery
}

export const getAllUsersResponseBody: GetAllUsersResponseBody = {
    ...baseResponseBody,
    data: {
        userId: getAllUsersParameter.userId,
        firstName: getAllUsersParameter.firstName,
        lastName: getAllUsersParameter.lastName,
        emailAddress: getAllUsersParameter.emailAddress,
        phone: getAllUsersParameter.phone,
        extension: getAllUsersParameter.extension,
        fax: getAllUsersParameter.fax,
        mobileNumber: getAllUsersParameter.mobileNumber,
        countryCode: getAllUsersParameter.countryCode,
        ptin: getAllUsersParameter.ptin,
        isMFAEnabled: getAllUsersParameter.isMFAEnabled,
        groupId: getAllUsersParameter.groupId,
        groupName: getAllUsersParameter.groupName,
        locationId: getAllUsersParameter.locationId,
        locationName: getAllUsersParameter.locationName,
        isPrimary: getAllUsersParameter.isPrimary,
    }
}

export const getAllUserGroupsResponseBody: GetAllUserGroupsResponseBody = {
    ...baseResponseBody,
    data: {
        groupId: getAllUserGroupsParameter.groupId,
        groupName: getAllUserGroupsParameter.groupName,
        groupDescription: getAllUserGroupsParameter.groupDescription,
        isDefault: getAllUserGroupsParameter.isDefault,
        roleId: getAllUserGroupsParameter.roleId,
        roleName: getAllUserGroupsParameter.roleName,
        products: getAllUserGroupsParameter.products,
    }
}

export const editUserRequestBody: EditUserRequestBody = {
    userId: editUserParameter.userId,
    firstName: editUserParameter.firstName,
    lastName: editUserParameter.lastName,
    emailAddress: editUserParameter.emailAddress,
    phone: editUserParameter.phone,
    extension: editUserParameter.extension,
    fax: editUserParameter.fax,
    mobileNumber: editUserParameter.mobileNumber,
    countryCode: editUserParameter.countryCode,
    ptin: editUserParameter.ptin,
    isMFAEnabled: editUserParameter.isMFAEnabled,
    userGroups: editUserParameter.userGroups,
    officeLocations: editUserParameter.officeLocations,
}

export const deleteUserRequestParameter: DeleteUserRequestParameter = {
    userIdQuery: deleteUserParameter.userIdQuery
}